export const SET_DRAFT = 'SET_DRAFT';
export const UPDATE_FORM = 'UPDATE_FORM';
export const SET_TRADE_CODES = 'SET_TRADE_CODES';
export const SET_UNIONS = 'SET_UNIONS';
export const SET_ROLES = 'SET_ROLES';
export const SET_SIMILAR_COMPANIES = 'SET_SIMILAR_COMPANIES';
export const SHOW_SIMILAR_COMPANIES_MODAL = 'SHOW_SIMILAR_COMPANIES_MODAL';
export const SHOW_REGISTERED_MODAL = 'SHOW_REGISTERED_MODAL';
export const SHOW_VERIFYING_MODAL = 'SHOW_VERIFYING_MODAL';
